import React from "react";
import { faBars, faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import fullLogo from "../resources/Artiq2.png";

export function WebHeader(props) {
  function showMenu() {
    props.setShowMenu(true);
  }
  return (
    <div className="WebHeader">
      <FontAwesomeIcon
        icon={faBars}
        size="2xl"
        className="icon-hover-effect"
        onClick={showMenu}
      />
      <img src={fullLogo} alt="ARTIQ" style={{ height: "75px" }} />
      <FontAwesomeIcon
        icon={faGear}
        size="2xl"
        className="icon-hover-effect"
        onClick={() => props.setShowProfile(true)}
      />
    </div>
  );
}
